"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = upload;

var _fetcher = _interopRequireDefault(require("./fetcher"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * 文件上传
 * @param {string} api
 * @param {object} options
 * @param {File} [options.file]
 * @param {FormData|object} [options.payload] 用于传递到 formData
 * @param {object} [options.search] 用于 url search 拼接
 * @param {object} [options.headers={}]
 * @return {Promise}
 */
async function upload(api, options) {
  options = _objectSpread({
    payload: {}
  }, options);
  let formData = new FormData();

  if (options.payload instanceof FormData) {
    formData = options.payload;
    options.payload = {};
  }

  let file = options.file;

  if (Object.prototype.toString.call(file) === '[object File]') {
    file = {
      name: 'file',
      file: file
    };
  }

  if (file && file.file) {
    formData.append(file.name || 'file', file.file);
  }

  for (const name in options.payload) {
    if (Object.prototype.hasOwnProperty.call(options.payload, name)) {
      const value = options.payload[name];
      formData.append(name, value);
    }
  }

  const {
    file: file2,
    payload,
    search
  } = options,
        fetchOptions = _objectWithoutProperties(options, ["file", "payload", "search"]);

  return (0, _fetcher.default)(api, _objectSpread({
    method: 'POST',
    payload: formData,
    data: search
  }, fetchOptions));
}

upload.init = function (config) {
  upload.hasInit = true;
};